import { RefObject } from 'react';
import { motion } from 'framer-motion';
import lockUrl from '../../../shared/assets/icon/lock.svg';
import { itemVariants, achievements } from '../../data/achievements';

interface Achievement {
  id: number;
  count: number;
  text: string;
}

interface AchievementItemProps {
  achievement: Achievement;
  index: number;
  count: number;
  nextIndex: number;
  listRef: RefObject<HTMLUListElement | null>;
}

const AchievementItem = ({
  achievement,
  index,
  count,
  nextIndex,
  listRef
}: AchievementItemProps) => {
  const isCompleted = count >= achievement.count;
  const isNext = index === nextIndex;
  const showProgress = isCompleted || isNext;
  const progressWidth = isCompleted
    ? 100
    : Math.min((count / achievement.count) * 100, 100);

  return (
    <motion.li
      key={achievement.id}
      className="content__achievement-article"
      initial={isCompleted ? false : 'hidden'}
      whileInView={isCompleted ? undefined : 'visible'}
      viewport={
        isCompleted ? undefined : { root: listRef, once: true, amount: 0.3 }
      }
      variants={itemVariants}
    >
      {count > achievement.count && (
        <p className="content__achievement-activated">
          <img
            className="content__achievement-icon"
            src={lockUrl}
            alt=""
            aria-hidden="true"
          />
          <span className="content__achievement-span">Рубеж закрыт</span>
        </p>
      )}
      <article className="content__achievement-content">
        <h3 className="content__achievement-number">
          {achievement.id === achievements.length
            ? 'Финальный рубеж'
            : `${achievement.id} рубеж`}
        </h3>
        <p className="content__achievement-text">{achievement.text}</p>
      </article>
      <p className="content__achievement-count">
        {achievement.count} активаций
      </p>
      {showProgress && (
        <div
          className="content__achievement-progress"
          aria-label={`Прогресс: ${Math.round(progressWidth)}%`}
        >
          <div
            className="content__achievement-progress-bar"
            style={{ width: `${progressWidth}%` }}
          />
        </div>
      )}
    </motion.li>
  );
};

export default AchievementItem;
